import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { SelectListItemModel } from '../../../models';
import { ContestSubmissionsSummaryModel } from '../../../models/contest';
import { AddToGalleryModel } from '../../../models/gallery';
import { ContestService, GalleryService, CreationService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'component-submissions',
    templateUrl: './contest.submissions.component.html'
})

export class ContestSubmissionsComponent implements OnInit {
    @Input() contestId: number;
    @BlockUI('conatiner-contest-submissions') blockUI: NgBlockUI;
    @BlockUI('conatiner-add-to-gallery') blockUIAddToGallery: NgBlockUI;

    private modalReference: any;

    public model: AddToGalleryModel = new AddToGalleryModel();

    public dataLoadCompleted = false;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private appUtils: AppUtils,
        private contestService: ContestService,
        private creationService: CreationService,
        private galleryService: GalleryService) {

        this.model.galleryId = '';
        this.toastr.setRootViewContainerRef(this.vcr);
    }

    public submissions: Array<ContestSubmissionsSummaryModel> = new Array<ContestSubmissionsSummaryModel>();
    public galleries: Array<SelectListItemModel> = new Array<SelectListItemModel>();
    public selectedSubmission: ContestSubmissionsSummaryModel = new ContestSubmissionsSummaryModel();

    ngOnInit() {
        this.getSubmissions();
        this.loadGalleries();
    }

    getSubmissions() {
        this.blockUI.start();
        this.contestService.getSubmissionsSummary(this.contestId)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.dataLoadCompleted = true;
                    Object.assign(this.submissions, data);
                },
                error => {
                    this.dataLoadCompleted = true;
                    this.blockUI.stop();
                    console.log(error);
                }
            );
    }

    loadGalleries() {
        this.galleryService.getSelectListItems()
            .subscribe(
                (data: any) => {
                    Object.assign(this.galleries, data);
                },
                error => {
                    console.log(error);
                }
            );
    }

    addToGallery() {
        this.blockUIAddToGallery.start();
        this.galleryService.addToGallery(this.model)
            .subscribe(
                () => {
                    this.blockUIAddToGallery.stop();
                    this.toastr.success('Contest has been added to gallery.');
                    this.close();
                },
                error => {
                    this.blockUIAddToGallery.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    openAddToGalleryModal(id: number, content: any) {
        this.model.contestSubmissionId = id;
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.modalReference.close();
    }

    vote(contestSubmission: ContestSubmissionsSummaryModel) {
        if (!this.appUtils.isUserAuthenticated()) {
            this.router.navigate(['/account/login']);
            setTimeout(() => {
                this.toastr.info('Please sign in to continue');
            }, 100);
            return;
        }
        if (contestSubmission.isVoted) {
            this.downVote(contestSubmission);
        } else {
            this.upVote(contestSubmission);
        }
    }

    upVote(contestSubmission: ContestSubmissionsSummaryModel) {
        this.blockUI.start();
        this.creationService.upVote(contestSubmission.id)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    contestSubmission.isVoted = true;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    downVote(contestSubmission: ContestSubmissionsSummaryModel) {
        this.blockUI.start();
        this.creationService.downVote(contestSubmission.id)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    contestSubmission.isVoted = false;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    openSubmission(content: any, creation: ContestSubmissionsSummaryModel) {
        this.selectedSubmission = creation;
        this.modalReference = this.modalService.open(content);
    }

    closeSubmission() {
        this.modalReference.close();
    }
}



// WEBPACK FOOTER //
// ./src/components/contest/submissions/contest.submissions.component.ts